import * as z from 'zod'

import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

const confirmations = () =>
  ({
    schema: z.object({}).passthrough(),
    stepContent: [
      {
        type: 'customComponent',
        name: 'ContentsConfirmations',
        inputs: [],
        outputs: [],
        props: {},
      },
    ],
    subFlow: SubFlow.PaymentAndConfirmation,
    nextStep: 'success',
    showOrderSummary: true,
  }) as const satisfies AnyStepConfiguration

export default confirmations
